import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { MailingSummary } from './types/mailing-summary.type';
import type { MergePurgeParameters } from './types/merge-purge-parameters.type';

/**
 * Fetches the mailing summary report for merge-purge operations.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param searchParams - The parameters for the merge-purge operation used as search parameters.
 * @returns A promise that resolves to an {@link OperationResultWithData} containing an array of {@link MailingSummary}.
 * @throws Will throw an error if the request fails.
 */
export const getMailingSummary = async (instance: KyInstance, searchParams: MergePurgeParameters) => {
  try {
    return await instance
      .get<OperationResultWithData<MailingSummary[]>>(Uri.reports.mergePurge.mailingSummary, {
        searchParams,
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
